
import React, { Component } from "react";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "leaflet-side-by-side";
import "./LeafletSideBySide.css";
import domain from "../../domain";
import { ClosedCaption } from "@material-ui/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobeAsia } from "@fortawesome/free-solid-svg-icons";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Control from "react-leaflet-control";
import colors from "../../colors";
import {
  Button,
  Segment,
  Grid,
  Message,
  Icon,
  Popup,
  Menu,
} from "semantic-ui-react";

function addCustomBaseLayerControl(baseLayers, overlayLayers, map) {
  const baseLayerControl = L.Control.extend({
      onAdd: function (map) {
          const container = L.DomUtil.create('div', 'leaflet-control-layers leaflet-control-layers-base');
          const iconHTML = '<div id="layerIcon" style="cursor: pointer; text-align: center;"><strong style="font-size: 17px;"><i class="fas fa-layer-group"></i> Layers </strong></div>';
          container.innerHTML = iconHTML;
          container.style.backgroundColor = '#FFFFFF';
          const overlayLayersContainer = L.DomUtil.create('div', 'overlay-layers', container);
          overlayLayersContainer.style.display = 'none'; // Initially hide the overlay layers container

          // Toggle the visibility of the overlay layers container when clicking the icon
          container.addEventListener('click', function (e) {
              if (overlayLayersContainer.style.display === 'none') {
                  overlayLayersContainer.style.display = 'block';
              } else {
                  overlayLayersContainer.style.display = 'none';
              }
              e.stopPropagation(); // Prevent click propagation to document
          });

          // Add base layers
          for (const key in baseLayers) {
              if (baseLayers.hasOwnProperty(key)) {
                  const checked = key === "Map" ? 'checked' : '';
                  overlayLayersContainer.innerHTML += `<label style="cursor: pointer;"><input type="radio" name="baseLayer" value="${key}" ${checked} /><strong style="background-color: #f8f9fa; padding: 2px 4px;">${key}</strong></label>`;
              }
          }
          // Add a divider
          overlayLayersContainer.innerHTML += `<hr class="layer-divider">`;
          // Add overlay layers
          for (const key in overlayLayers) {
              if (overlayLayers.hasOwnProperty(key)) {
                                  //const overlayName = key.replace(/([a-z])([A-Z])/g, '$1 $2');

                const overlayName = key.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/\bAnd\b/g, '&');
                //overlayLayersContainer.innerHTML += `<label><input type="checkbox" name="overlayLayer" value="${key}" /> <strong style="background-color: #f8f9fa; padding: 2px 4px; ">${overlayName}</strong></label>`;
                  overlayLayersContainer.innerHTML += `<label style="cursor: pointer;display: block; padding: 4px 0;"><input type="checkbox" name="overlayLayer" value="${key}" /> <strong style="background-color: #f8f9fa; padding: 2px 4px; ">${overlayName}</strong></label>`;

                }
          }
          // Handle changes in layer selection
          overlayLayersContainer.addEventListener('change', function (e) {
              const target = e.target;
              if (target.type === 'radio') {
                  const layerName = target.value;
                  for (const key in baseLayers) {
                      if (baseLayers.hasOwnProperty(key)) {
                          map.removeLayer(baseLayers[key]);
                      }
                  }
                  baseLayers[layerName].addTo(map);
              } else if (target.type === 'checkbox') {
                  const layerName = target.value;
                  if (target.checked) {
                      overlayLayers[layerName].addTo(map);
                  } else {
                      map.removeLayer(overlayLayers[layerName]);
                  }
              }
          });
          // Prevent closing the container when clicking inside it
          overlayLayersContainer.addEventListener('click', function (e) {
              e.stopPropagation();
          });
          // Close the container if clicked outside
          document.addEventListener('click', function () {
              overlayLayersContainer.style.display = 'none';
          });
          return container;
      }
  });
  map.addControl(new baseLayerControl());
}

class CompareSwipe extends Component {
  constructor(props) {
      super(props);
      this.mapRef = React.createRef();
      this.map = null;
      this.sideBySideControl = null;
      this.india3LayerLeft = null;
      this.india3LayerRight = null;
      this.state = {
        
        legendVisible: true,
        legendscf: null, //snow cover fraction
        legendother: null, //for forecast and actual
        compareLeftWorkspace: null,
      compareLeftLayer: null,
      compareRightWorkspace: null,
      compareRightLayer: null,
          leftPanelHeading: "",
          rightPanelHeading: "",
          baseLayer: "Map", // Default base layer
          baseLayers: {
              Map: L.tileLayer.wms(
                  "https://bhuvan-vec1.nrsc.gov.in/bhuvan/gwc/service/wms",
                  {
                      layers: "india3",
                      format: "image/png",
                      transparent: true,
                      version: "1.1.1",
                      zIndex: 0,
                  }
              ),

              Satellite: L.tileLayer.wms(
                  //"https://bhuvan-ras2.nrsc.gov.in/tilecache/tilecache.py?service=WMS&request=GetMap&layers=bhuvan_img&styles=&format=image%2Fjpeg&transparent=true&version=1.1.1&srs=EPSG%3A4326&maxZoom=15&minZoom=3",
                 "https://bhuvan-ras2.nrsc.gov.in/tilecache/tilecache.py", 

                // "https://bhuvan-ras2.nrsc.gov.in/tilecache/tilecache.py?service=WMS&request=GetMap&layers=bhuvan_img&styles=&format=image%2Fpng&transparent=true&version=1.1.1&width=256&height=256&srs=EPSG%3A4326&maxZoom=15&minZoom=3",
                 
                 {
                  layers: "bhuvan_img",  
                  format: "image/png",  
                  transparent: true,
                  version: "1.1.1",
                  tileSize: 256,
                      zIndex: 0
                  }
              )
          },
          overlayLayers: {
              ShadedRelief: L.tileLayer.wms(
                  "https://bhuvan.nrsc.gov.in/nhpgs/nhp_snowcomponent/wms",
                  {
                      layers: "nhp_snowcomponent:DEM",
                      format: "image/png",
                      transparent: true,
                      version: "1.1.1",
                      maxZoom: 15,
                      minZoom: 3,
                      tileSize: 256,
                      zIndex: 2
                  }
              ),
              
              LULC: L.tileLayer.wms(
                  "https://bhuvan.nrsc.gov.in/nhpgs/nhp_snowcomponent/wms",
                  {
                      layers: "nhp_snowcomponent:snow_lulc",
                      format: "image/png",
                      transparent: true,
                      version: "1.1.1",
                      maxZoom: 15,
                      minZoom: 3,
                      tileSize: 256,
                      zIndex: 2,
                  }
              ),
        
              BasinsAndDischargeOutlets: L.tileLayer.wms(
                "https://bhuvan.nrsc.gov.in/nhpgs/nhp_snowcomponent/wms",
                {
                    layers: "nhp_snowcomponent:DischargeOutlet,nhp_snowcomponent:Basin",
                    format: "image/png",
                    transparent: true,
                    version: "1.1.1",
                    maxZoom: 15,
                    minZoom: 3,
                    tileSize: 256,
                    zIndex: 2,
                     title: "Basin & Discharge Outlets"
                }
            ),
             
              DrainageNetwork: L.tileLayer.wms(
                  "https://bhuvan.nrsc.gov.in/nhpgs/nhp_snowcomponent/wms",
                  {
                      layers: "nhp_snowcomponent:snow_river",
                      format: "image/png",
                      transparent: true,
                      version: "1.1.1",
                      maxZoom: 15,
                      minZoom: 3,
                      tileSize: 256,
                      zIndex: 12,
                      opacity: 7.6,
                  }
              ),
              Glaciers: L.tileLayer.wms(
                "https://bhuvan.nrsc.gov.in/nhpgs/nhp_snowcomponent/wms",
                {
                    layers: "nhp_snowcomponent:GlacierBlue",
                    format: "image/png",
                    transparent: true,
                    version: "1.1.1",
                    maxZoom: 15,
                    minZoom: 3,
                    zIndex: 17,
                    tileSize: 256,
                    opacity: 100.4,    
                }
            ),
          //   Basins: L.tileLayer.wms(
          //     "https://bhuvan.nrsc.gov.in/nhpgs/nhp_snowcomponent/wms",
          //     {
          //         layers: "nhp_snowcomponent:Basin",
          //         format: "image/png",
          //         transparent: true,
          //         version: "1.1.1",
          //         maxZoom: 15,
          //         minZoom: 3,
          //         tileSize: 256,
          //         zIndex: 14,
          //         opacity: 8, 
          //       //  opacity: 0.5,
          //     }
          // ),
          },
      };
  }
  
  componentDidMount() {
    this.initializeMap();
    this.updateLegends(); // Initialize legends
    this.resetDropdown(); // Reset dropdown when the component mounts

  
  }
  componentDidUpdate(prevProps) {
    console.log('Component updated');
    console.log('Previous snowproductselected:', prevProps.snowproductselected);
    console.log('Current snowproductselected:', this.props.snowproductselected);
    
    if (
      prevProps.compareLeftWorkspace !== this.props.compareLeftWorkspace ||
      prevProps.compareLeftLayer !== this.props.compareLeftLayer ||
      prevProps.compareRightWorkspace !== this.props.compareRightWorkspace ||
      prevProps.compareRightLayer !== this.props.compareRightLayer ||
      prevProps.basinoverlays !== this.props.basinoverlays ||
      prevProps.snowproductselected !== this.props.snowproductselected
    ) {
      this.updateLayer();
      this.updatePanelHeadings();
      this.updateLegends(); // Update legends if snowproductselected prop changes
   
    }
  }

  componentWillUnmount() {
    this.resetDropdown(); // Reset dropdown when the component unmounts
    this.resetSelection();
    this.resetLegends(); // Reset legends when the component unmounts
    this.resetState();
  }
  
  initializeMap() {
    const indiamapcenter =
    window.innerWidth > 1000 ? [34.12539, 83.00164] : [20.13, 80.58];
    this.map = L.map(this.mapRef.current, {
      crs:L.CRS.EPSG4326,
      dragging: true
    }).setView(indiamapcenter,5.4,this.props.maxZoom,this.props.zoom);
 // Add the "Map" base layer to the map initially
  addCustomBaseLayerControl(this.state.baseLayers, this.state.overlayLayers, this.map);

    this.state.baseLayers.Map.addTo(this.map);
    const boundary = L.geoJSON(this.props.himalayan_boundary, {
      style: {
        weight: 3,
        color: "#0000FF",
        fill: false,
        fillOpacity: 1,
        //dashArray: "7, 8"
      },
      onEachFeature: function (feature, layer) {
        if (feature.properties && feature.properties.popupContent) {
          layer.bindPopup(feature.properties.popupContent);
        }
      }
    }).addTo(this.map);

    this.props.basinoverlays.forEach((overlay) => {
      if (overlay.isChecked) {
        L.tileLayer.wms(
          `${domain.Geoserver}/nhp_snowcomponent/wms`,
          {
            layers: `nhp_snowcomponent:${overlay.value}`,
            format: "image/png",
            transparent: true,
            version: "1.1.1",

            zIndex: 2
          }
        ).addTo(this.map);
      }
    });

    this.india3LayerLeft = L.tileLayer.wms(
      `https://bhuvan.nrsc.gov.in/nhpgs/${this.props.compareLeftWorkspace}/wms`,
      {
        layers: this.props.compareLeftLayer,
        format: "image/png",
        transparent: true,
        version: "1.1.1",
        maxZoom: 15,
        minZoom: 3,
        tileSize: 256,
        crs: L.CRS.EPSG4326,
        zIndex: 5
      }
    );

    this.india3LayerRight = L.tileLayer.wms(
      `https://bhuvan.nrsc.gov.in/nhpgs/${this.props.compareRightWorkspace}/wms`,
      {
        layers: this.props.compareRightLayer,
        format: "image/png",
        transparent: true,
        version: "1.1.1",
        maxZoom: 15,
        minZoom: 3,
        tileSize: 256,
        crs: L.CRS.EPSG4326,
        zIndex: 5
      }
    );

    L.control.layers(this.state.overlayLayers).addTo(this.map);
    const mapPane = this.map.getPane("mapPane");
    if (mapPane) {
        mapPane.classList.add("leaflet-map-pane-adjusted");
    }
    this.sideBySideControl = L.control.sideBySide(this.india3LayerLeft, this.india3LayerRight);
    this.sideBySideControl.addTo(this.map);
    this.updatePanelHeadings();
}

  updateLayer() {
    try {
        this.map.removeLayer(this.india3LayerLeft);
        this.map.removeLayer(this.india3LayerRight);
        this.india3LayerLeft = L.tileLayer.wms(
            `https://bhuvan.nrsc.gov.in/nhpgs/${this.props.compareLeftWorkspace}/wms`,
            {
                layers: this.props.compareLeftLayer,
                format: "image/png",
                transparent: true,
                version: "1.1.1",
                maxZoom: 15,
                minZoom: 3,
                tileSize: 256,
                crs: L.CRS.EPSG4326,
                zIndex: 5
            }
        );

        this.india3LayerRight = L.tileLayer.wms(
            `https://bhuvan.nrsc.gov.in/nhpgs/${this.props.compareRightWorkspace}/wms`,
            {
                layers: this.props.compareRightLayer,
                format: "image/png",
                transparent: true,
                version: "1.1.1",
                maxZoom: 15,
                minZoom: 3,
                tileSize: 256,
                crs: L.CRS.EPSG4326,
                zIndex: 5
            }
        );

        // Remove all overlay layers
        // this.map.eachLayer((layer) => {
        //     if (layer instanceof L.TileLayer && !this.props.basinoverlays.find((overlay) => overlay.value === layer.options.layers && overlay.isChecked)) {
        //         this.map.removeLayer(layer);
        //     }
        // });

      // Add back the base layer if it's not already added
      if (!this.map.hasLayer(this.state.baseLayers[this.state.baseLayer])) {
        this.state.baseLayers[this.state.baseLayer].addTo(this.map);
    }
        this.india3LayerLeft.addTo(this.map);
        this.india3LayerRight.addTo(this.map);
        this.sideBySideControl.setLeftLayers(this.india3LayerLeft);
        this.sideBySideControl.setRightLayers(this.india3LayerRight);
        this.updatePanelHeadings();
    } catch (error) {
        console.error("Error updating layers", error);
    }
};

updatePanelHeadings() {
  const { compareLeftLayer, compareRightLayer } = this.props;
  
  const getProductTitle = (layer) => {
      const product = layer.split(":")[0];
      const formattedProduct = product.replace("nhp_", "").replace(/-/g, " ").toLowerCase().split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
      if (product === "nhp_forecast") {
        return "Snowmelt Rate Forecast";
    }
    if (product === "nhp_actual")
    {
      return "Daily Snowmelt Rate";
    }
      return formattedProduct;
  };

  const getDateFormatted = (layer) => {
    const date = layer.split("_").slice(-1)[0];
    const formattedDate = `${date.slice(6, 8)}-${date.slice(4, 6)}-${date.slice(0, 4)}`;
    const monthNames = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const month = monthNames[parseInt(date.slice(4, 6), 10)];
    const productTitle = getProductTitle(layer);
    return <strong>{productTitle}: {formattedDate.slice(0, 2)}-{month}-{formattedDate.slice(6, 10)}</strong>;
};

  const leftPanelHeading = compareLeftLayer ? getDateFormatted(compareLeftLayer) : <span style={{ fontWeight: 'bold' }}>Left Panel</span>;
  const rightPanelHeading = compareRightLayer ? getDateFormatted(compareRightLayer) : <span style={{ fontWeight: 'bold' }}>Right Panel</span>;
  this.setState({
      leftPanelHeading: leftPanelHeading,
      rightPanelHeading: rightPanelHeading
  });
}

handleReset = () => {
  // Reset the map view to its initial state
  this.map.setView([34.12539, 83.00164], 5.4);
  // Add the "Map" base layer to the map
  this.state.baseLayers.Map.addTo(this.map);
  // Remove other layers from the map
  Object.values(this.state.baseLayers).forEach(layer => {
      if (layer !== this.state.baseLayers.Map && this.map.hasLayer(layer)) {
          this.map.removeLayer(layer);
      }
  });
  // Reset the left and right layers
  this.india3LayerLeft.setParams({ layers: this.props.compareLeftLayer });
  this.india3LayerRight.setParams({ layers: this.props.compareRightLayer });
  // Update the panel headings
  this.updatePanelHeadings();
};

handleBaseLayerChange = (e) => {
  const selectedBaseLayer = e.target.value;
  console.log("all layers selected",e.target.value)
  // Remove current base layer from the map
  this.map.removeLayer(this.state.baseLayers[this.state.baseLayer]);
  // Add the selected base layer to the map
  this.setState({
    baseLayer: selectedBaseLayer
  }, () => {
    this.state.baseLayers[selectedBaseLayer].addTo(this.map);
  });
};

resetSelection() {
  this.setState({
    compareLeftWorkspace: null,
    compareLeftLayer: null,
    compareRightWorkspace: null,
    compareRightLayer: null,
    // leftPanelHeading: "",
    // rightPanelHeading: "",
  });
}
resetDropdown = () => {
  
  this.setState({
    compareLeftWorkspace: null,
    compareLeftLayer: null,
    compareRightWorkspace: null,
    compareRightLayer: null,
   leftPanelHeading: "",
   rightPanelHeading: "",
  });
}

resetLegends = () => {
  this.setState({
    legendVisible: false,
    legendscf: null,
    legendother: null,
  });
}

resetState() {
  this.setState({
    leftPanelHeading: "",
    rightPanelHeading: "",
    baseLayer: "Map", // Reset base layer to default
    legendscf: null, // Reset legends
    legendother: null,
  });
}
updateLegends = () => {
  console.log('Updating legends...');
  console.log('Selected product:', this.props.snowproductselected);
  const snf_colors_range = [
    "#f7fbff",
    "#deebf7",
    "#c6dbef",
    "#9ecae1",
    "#6baed6",
    "#4292c6",
    "#2171b5",
    "#08519c",
    "#08306b",
    "#154360",
    "#000ad5",
  ];
  const snf_grades = [
    "1-10",
    " 10-20",
    " 20-30",
    " 30-40",
    " 40-50",
    " 50-60",
    " 60-70",
    " 80-90",
    " 90-100",
  ];

  let snf_img = snf_grades.map((value, key) => {
    return (
      <React.Fragment>
      <i key={key} style={{ background: `${snf_colors_range[key]}` }}></i>{" "}
      {value} <br />{" "}
    </React.Fragment>
    );
  });

  let sna_img = (
    <div
    style={{
      textAlign: "center",
      fontSize: "12px",
      display: "flex",
      justifyContent: "center",
    }}
  >
    <div className="sma_color_scale"></div>
      <div style={{ float: "left", paddingLeft: "5px", marginTop: "0px" }}>
        1<br />
        10
        <br />
        20
        <br />
        30
        <br />
        40
        <br />
        50
        <br />
      </div>
    </div>
  );
  
  if (this.props.snowproductselected === "Snow Cover Fraction") {
    this.setState({
      legendscf: snf_img,
      legendother: null, // Reset the other legend
    });
  } else if (
    this.props.snowproductselected === "Snowmelt Rate Forecast" 
  ) {
    this.setState({
      legendscf: null, // Reset the other legend
      legendother: sna_img,
    });
    }  else if (
      this.props.snowproductselected === "Daily Snowmelt Rate"
    ){
      this.setState({
        legendscf: null, // Reset the other legend
        legendother: sna_img,
      });
  }
};

render() {
  console.log('Rendering component...');
  console.log('Legends SCF:', this.state.legendscf);
  console.log('Legend Other:', this.props.snowproductselected  );
  return (
    
    <div>
      <div className="left-panel-heading">{this.state.leftPanelHeading}</div>
      <div className="right-panel-heading">{this.state.rightPanelHeading}</div>
   
      <div id="map" ref={this.mapRef} style={{ height: "99vh", width: "100%", position: "fixed" }} />
      
      {/* {window.innerWidth > 1000 && (
        <Button
       
          onClick={this.props.handleAnimationChange}
          secondary
          style={{
            position: 'absolute',
            top: '120px',
            left: '-12px',
            backgroundColor: colors.sidebar,
            zIndex: '1000',
            marginLeft: "10px",
            transition: "left 0.3s ease-in-out"
          }}
          compact
          size="mini"
          title="Minimize/Maximize Product Selection Panel"
        >
          <FontAwesomeIcon icon="th-list" size="sm" />
        </Button>
        
      )} */}
     
      <div style={{ position: 'absolute', top: '80px', left: '14px', zIndex: '1000', backgroundColor: 'silver', borderRadius: '0%', padding: '5px',  popupContent:"Map Reset" }}>
     <FontAwesomeIcon icon={faGlobeAsia} size="lg" onClick={this.handleReset}  />
      </div> 
      {/* <div style={{ position: 'absolute', top: '120px', left: '14px', zIndex: '1000', backgroundColor: 'silver', borderRadius: '0%', padding: '5px' }}>
  <FontAwesomeIcon icon={faSyncAlt} size="lg" onClick={this.handleFullReset} />
</div> */}

      {this.props.snowproductselected === "Snow Cover Fraction" && (
        <div style={{ position: 'absolute', top: '100px', right: '155px', zIndex: '1000',  textAlign: "left",
        width: "20%",
        marginRight: "-60px" }}>
           <h3 style={{ fontWeight: 700, fontSize: 15}}>Snow Cover Fraction</h3>
          <div className="info legend" style={{ marginLeft: "40px" }}>{this.state.legendscf}</div>   
        </div>
      )}
      {this.props.snowproductselected === "Snowmelt Rate Forecast"  && (
        <div style={{ position: 'absolute', top: '100px', right: '145px', zIndex: '1000',  textAlign: "left",
        width: "20%",
        marginRight: "-43px"  }}>
         <h3 style={{ fontWeight: 700, fontSize: 15 }}>Snowmelt Rate Forecast (mm/day)</h3>
          <div className="info legend"  style={{ marginLeft: "50px" }}>{this.state.legendother}</div>
        </div>
      )}
       {this.props.snowproductselected === "Daily Snowmelt Rate" && (
        <div style={{ position: 'absolute', top: '100px', right: '145px', zIndex: '1000',  textAlign: "left",
        width: "20%",
        marginRight: "60px"  }}>
          <h3 style={{ fontWeight: 700, fontSize: 15 }}>Daily Snowmelt Rate (mm/day)</h3>
          <div className="info legend"  style={{ marginLeft: "40px" }}>{this.state.legendother}</div>
        </div>
      )}
     {this.props.snowproductselected === "Daily Snow Cover" && (
  <div style={{ position: 'absolute', top: '100px', right: '145px', zIndex: '1000', textAlign: "right", width: "20%", marginRight: "100px" }}>
    <h3 style={{ fontWeight: 700, fontSize: 15 }}>Daily Snow Cover</h3>
    <img src="https://bhuvan.nrsc.gov.in/nhpgs/nhp_daily-snow-cover/wms?request=GetLegendGraphic&layer=daily-snow-cover:snowcover_20240509&format=image/png&width=40&height=10&legend_options=dpi:100" alt="Legend" style={{ marginRight: "20px" }}/>
  </div>
)}  
    </div>
    
  );
}
}

export default CompareSwipe;